module.exports = __webpack_public_path__ + "static/media/andjce-formulaire-candidature-prix-des-Humanités-.14cccb39.pdf";